import {useContext} from "react";
import {AppContext} from "../context/appContext/AppContext";

const useAppContext = () => {
    return useContext(AppContext);
}

export default useAppContext;